import { useEffect } from 'react';

/**
 * Stelt document title en meta description in voor SEO.
 * @param {string} title - Paginatitel (wordt " - OfferteRunner" toegevoegd)
 * @param {string} description - Meta description (max ~160 tekens)
 */
export default function PageMeta({ title, description }) {
  useEffect(() => {
    const fullTitle = title ? `${title} - OfferteRunner` : 'OfferteRunner - Professionele offertes in minuten';
    document.title = fullTitle;

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    if (description) {
      meta.setAttribute('content', description.slice(0, 160));
    }

    return () => {
      document.title = 'OfferteRunner - Professionele offertes in minuten';
      if (meta && description) meta.setAttribute('content', 'Maak professionele offertes in minuten. Koppeling met Odoo en AI-teksten. Voor ZZP en MKB.');
    };
  }, [title, description]);

  return null;
}
